import React, { PureComponent } from 'react';
import Dropdown from '../standardAttributes/Dropdown';
import { IN_TO_M, BACKSTOP_OFFSET } from '../../../constants';
import { getNodeInfo } from '../../../helper/config';
import message from '../../../helper/message';

export default class BelowPopularBackstop extends PureComponent {
  removeModel = (block, newAppState) => {
    const { appApi, actions, configuration, attributeName } = this.props;
    const { modelId, value } = configuration[attributeName];
    if (!modelId) return newAppState;
    const { height } = appApi.config.getProduct(value);
    block && block.unoccupyBlocks(modelId);
    newAppState = actions.removeModel(modelId, newAppState);
    if (configuration.uprights.blocks) {
      const uprightFrontBlock = configuration.uprights.blocks.uprightFront;
      uprightFrontBlock.addRows(
        Array(height - BACKSTOP_OFFSET).fill(1 * IN_TO_M)
      );
    }
    return newAppState;
  };
  importModel = async (value, block) => {
    const { appApi, attributeName, configuration } = this.props;
    const { hasScene, blockDependOn } = appApi.config.getAttribute(
      attributeName
    );
    if (!hasScene || value === 'None') return;
    if (!block)
      throw new Error(`Attribute ${attributeName} missing dependOn block!`);

    const product = appApi.config.getProduct(value);
    const { sceneId, height } = product;
    const validHeight = height - BACKSTOP_OFFSET;
    const nodeInfo = getNodeInfo(product);
    nodeInfo.height = validHeight * IN_TO_M;

    const insertion = block.determineInsertion(nodeInfo);
    if (!insertion.isInsertionPossible)
      return message.error(
        `Fail to insert ${attributeName}, please check either the dimension  or the compatibility of product ${value}!`
      );

    let uprightInsertion = true;
    const uprightFrontBlock =
      configuration.uprights.blocks &&
      configuration.uprights.blocks.uprightFront;
    if (uprightFrontBlock) {
      const row = uprightFrontBlock.rowTranslation.length - validHeight;
      const option = { row, col: 0 };
      nodeInfo.width = uprightFrontBlock.totalWidth;
      uprightInsertion = uprightFrontBlock.determineInsertion(nodeInfo, option)
        .isInsertionPossible;
    }
    if (!uprightInsertion) return;

    uprightFrontBlock && uprightFrontBlock.deleteRows(validHeight);
    const transform = block.getInsertTransform(insertion);
    const parent = configuration[blockDependOn[0][0]].modelId;
    const blocksData = appApi.config.getProductBlockData(attributeName);
    const importOPtions = { blocksData, parent, transform };
    const importState = await appApi.model.importModel(sceneId, importOPtions);
    block.occupyBlocks(importState.modelId, insertion);
    return importState;
  };
  render() {
    return (
      <Dropdown
        {...this.props}
        removeModel={this.removeModel}
        importModel={this.importModel}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/nonStandardAttributes/BelowPopularBackstop.js